import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import Card from './card';
import WrapperAndContent from './wrapper';
import { AccountsService } from '@packages/contexts/accounts';
import { getLogger } from '@packages/core/logging';
import { Account } from '@packages/models/api';
import { useAuthState } from '@packages/contexts/auth';

const logger = getLogger('ui');

// FIXME: InfoCard should be purely presentational; it should receive contact info as props instead of
//        fetching it internally via accountService. The accountService prop forces every consumer to
//        import and thread through a service singleton from the app layer.
//        - Luke C, 03/09/2026, TECHSHARE-5977
interface Props {
    content: string;
    accountService: AccountsService;
    accountId?: string;
    userName?: string;
    contentZIndex?: number | string;
}

const InfoCard: FC<Props> = (props) => {
    const [isValid, setIsValid] = useState(false);
    const [userInfo, setUserInfo] = useState<Account>();
    const { account } = useAuthState();
    const { userName, accountId, accountService } = props;

    const hasPermission = useMemo(() => {
        const roleHavePermission = ['LAG_SUPER_ADMIN', 'QA_ADMIN', 'SOA_SUPER_USER', 'DSQM', 'RSQM'];
        return account?.baseRoleIds.some((roleId) => roleHavePermission.includes(roleId));
    }, [account]);

    useEffect(() => {
        if (hasPermission && (Boolean(userName) || Boolean(accountId))) {
            fetchInfo();
        }
    }, [accountService, userName, accountId, hasPermission]);

    const fetchInfo = useCallback(() => {
        try {
            accountService.getUserInfoCardDetails({ accountId, userName }).then((res) => {
                if (res.success) {
                    setIsValid(true);
                    setUserInfo(res.data.account);
                }
            });
        } catch (error) {
            logger.warn('Failed to fetch the user info card details', { accountId, error, userName });
        }
    }, [accountId, accountService, userName]);

    const contactInfo = {
        name: userInfo?.firstName,
        jobTitle: userInfo?.jobTitleDescription,
        phoneNumber: userInfo?.phoneNumbers?.[0]?.phoneNumber,
        email: userInfo?.emailAddresses?.[0]?.emailAddress,
        locationDetails: userInfo?.locationsDescription,
    };

    return (
        <>
            <WrapperAndContent content={props.content} isValid={isValid} contentZIndex={props.contentZIndex}>
                <Card contactInfo={contactInfo} />
            </WrapperAndContent>
        </>
    );
};

export default InfoCard;
